import { Row, Col } from '../../components/custom';

import firstImage from '../../images/sample/MII/one.webp';
import secondImage from '../../images/sample/MII/two.webp';
import thirdImage from '../../images/sample/MII/three.webp';
import fourthImage from '../../images/sample/MII/four.webp';
import fifthImage from '../../images/sample/MII/five.webp';
import sixthImage from '../../images/sample/MII/six.webp';
import seventhImage from '../../images/sample/MII/seven.webp';

export default function MII()
{
    return (
        <Col id='MII'>
            <Col className='banner'>
                <span className='title'>What the Market Is Saying</span>
                <span className='desc'>Voice Beyond the Survey</span>
            </Col>
            <Col className='section' data-id='1'>
                <Col>
                    <span className='title'>Analyzing Employer Brand Perception </span>
                    <span className='desc'>Majority of employees express satisfaction, indicating a generally healthy work environment.</span>
                </Col>
                <Row className='images'>
                    <img src={firstImage} alt='firstImage'/>
                    <img src={secondImage} alt='secondImage'/>
                </Row>
                <Row>
                    <img src={thirdImage} alt='thirdImage'/>
                    <Col>
                        <span className='descsmall'>The sentiment analysis reveals that while a majority of employees express positive feelings—particularly around flexibility, support, and learning—there are consistent concerns regarding leadership trust, career progression, and internal communication.</span>
                        <span className='descsmall'>Topic modeling highlights that leadership and transparency are frequently discussed, indicating that employees are closely observing the behavior and clarity from management.</span>
                        <span className='descsmall'>The presence of mixed sentiment around recognition and workload also points to inconsistencies in how employee efforts are acknowledged and how responsibilities are managed.</span>
                    </Col>
                </Row>
            </Col>
            <Col className='section' data-id='2'>
                <Col>
                    <span className='title'>Decoding Review Themes Across Competitors</span>
                    <span className='desc'>Analyzing sentiment and themes to shape your brand narrative</span>
                    <span className='descsmall'>The topic modeling analysis reveals that <strong>Our Product stands out with the highest mentions for ease of use and overall satisfaction</strong>, reflecting a strong user experience and intuitive design. In contrast, <strong>CompA and CompB show more balanced mentions across themes</strong>, with slightly higher attention on customer support and pricing, indicating ongoing user concerns in those areas.</span>
                </Col>
                <Row>
                    <img src={fourthImage} alt='fourthImage'/>
                    <img src={fifthImage} alt='fifthImage'/>
                    <img src={sixthImage} alt='sixthImage'/>
                </Row>
                <span className='descsmall'>The enhanced word cloud reinforces this narrative, with users frequently describing Our Product as "intuitive," "scalable," "efficient," and "dependable." In comparison, competitor brands lack such dominant positive sentiment markers. These findings present a valuable opportunity to <strong>leverage usability and reliability as differentiators</strong> in go-to-market messaging, while continuing to monitor areas like scalability and support to maintain the product's competitive edge.</span>
            </Col>
            <Col className='section' data-id='3'>
                <Col>
                    <span className='title'>Tracing Customer Pain Across the Journey</span>
                    <span className='desc'>How feedback sources connect to drop-off points and service breakdowns</span>
                </Col>
                <img src={seventhImage} alt='seventhImage'/>
                <Col>
                    <span className='descsmall'>The Sankey chart reveals that most billing-related pain points stem from complaints, while onboarding delays and support issues originate from reviews and tickets. Support concerns like unhelpful agents and slow responses are especially frequent.</span>
                    <span className='descsmall'>To address this, businesses should enhance billing clarity, streamline onboarding, and invest in faster, more empathetic customer support.</span>
                </Col>
            </Col>
        </Col>
    )
}